// ---------------------------------------------------------------------------
// PWA_ControlBillet — Toast notification component
// Reads from useAppStore().toastMessage, auto-hides after 3s.
// ---------------------------------------------------------------------------

import { useEffect } from 'react';
import { useAppStore } from '@/store/app-store';

const BG_MAP = {
  success: 'bg-success',
  error: 'bg-danger',
  warning: 'bg-warning',
} as const;

export function Toast() {
  const toastMessage = useAppStore((s) => s.toastMessage);
  const hideToast = useAppStore((s) => s.hideToast);

  useEffect(() => {
    if (!toastMessage) return;

    const timer = setTimeout(() => {
      hideToast();
    }, 3000);

    return () => clearTimeout(timer);
  }, [toastMessage, hideToast]);

  if (!toastMessage) return null;

  const bgClass = BG_MAP[toastMessage.type];

  return (
    <div className="fixed bottom-20 left-1/2 -translate-x-1/2 z-50 animate-fade-in">
      <div
        className={`${bgClass} rounded-xl px-6 py-3 shadow-lg min-w-[200px] max-w-[90vw]`}
        role="alert"
      >
        <p className="text-white text-base font-semibold text-center">
          {toastMessage.text}
        </p>
      </div>
    </div>
  );
}
